import React from "react";
import styled, { css } from "styled-components";
import { theme } from "@ui/styles/theme";
import { gap } from "@ui/styles/utils";
import { checkboxInputCss } from "./checkboxInput";

interface RadioButtonProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	id: string;
	name: string;
	value?: string;
	disabled?: boolean;
	onChange: (v: string) => void;
	checked?: boolean;
	label?: string;
	labelStyle?: ReturnType<typeof css>;
	checkbox?: boolean;
}
export const RadioButton: React.FC<RadioButtonProps> = ({
	id,
	checkbox,
	name,
	disabled = false,
	checked,
	label,
	labelStyle,
	value,
	onChange,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps} labelStyle={labelStyle}>
			<input
				id={id}
				disabled={disabled}
				type={checkbox ? "checkbox" : "radio"}
				value={value}
				name={name}
				checked={checked}
				onChange={(e) => onChange(e.currentTarget.value)}
			/>
			{label && !disabled && <label htmlFor={id}>{label}</label>}
			{label && disabled && (
				<label htmlFor={id} color={theme.colors.red}>
					{label}
				</label>
			)}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "labelStyle",
})<{ labelStyle?: ReturnType<typeof css> }>`
	${gap(12, "row")};

	label {
		${({ labelStyle }) => labelStyle ?? undefined};
		cursor: pointer;
	}
	input {
		cursor: pointer;
		vertical-align: bottom;
		width: 20px;
		height: 20px;
		position: relative;
		appearance: none;
		outline: none;

		&[type="radio"] {
			border: 1px solid ${({ theme }) => theme.colors.gray};
			border-radius: 10px;

			&:checked::after {
				content: "";
				position: absolute;
				top: 4px;
				left: 4px;
				right: 4px;
				bottom: 4px;
				background-color: ${({ theme }) => theme.colors.primary};
				border-radius: 10px;
				border: none;
			}
		}

		&[type="checkbox"] {
			${checkboxInputCss};
			margin-right: 12px;
		}
	}
`;
